import { CircleAlert, RefreshCcw } from '@tamagui/lucide-icons';
import { Button } from '@unistocks/components/button/button';
import { Center } from '@unistocks/components/layout/center';
import { Paragraph } from '@unistocks/components/text/text';
import { useDevToolsEnabled } from '@unistocks/shared/hooks/use-feature';
import { t } from '@unistocks/shared/localization/index.ts';
import React from 'react';
import { ViewProps } from 'tamagui';

export type ErrorMessageProps = ViewProps & {
  error?: any;
  message?: string;
  onRetry?: () => void;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  error,
  message = t('::DefaultErrorMessage'),
  onRetry,
  ...props
}) => {
  const isDev = useDevToolsEnabled();

  return (
    <Center
      transition={'quickLessBouncy'}
      gap={'$3'}
      enterStyle={{
        o: 0,
        y: -20
      }}
      exitStyle={{
        o: 0,
        y: -20
      }}
      {...props}
    >
      <CircleAlert size={'$8'} strokeWidth={2.5} color={'$danger'} />
      {message ? <Paragraph size={'$7'}>{message}</Paragraph> : null}
      {isDev && error?.message ? <Paragraph size={'$5'}>{error.message}</Paragraph> : null}
      {onRetry ? (
        <Button size={'$3'} variant={'outlined'} Icon={RefreshCcw} onPress={onRetry}>
          {t('::Retry')}
        </Button>
      ) : null}
    </Center>
  );
};
